window.theme_vars = window.theme_front;
jQuery(function($){
    var start = new Date(),
    last = new Date();

    var logTime = function(name){

        if ( 1 ) {
            return;
        }

        var now = new Date();
        var sinceLast = now.getTime() - last.getTime();
        var sinceStart = now.getTime() - start.getTime();
        last = now;

        if ( window.console && console.info ){

            console.info(
                name,
                //(Math.round(sinceLast)/1000)+'s since last',
                (Math.round(sinceStart)/1000)+'s'
            )
        }
    }
    logTime('Starting');
    var breakpoints = {
        XS : 0,
        SM : 768,
        MD : 992,
        LG : 1200
    };
    $.breakpoints([breakpoints.SM,breakpoints.MD,breakpoints.LG]);

    /**
    * All Sites
    */
    (function all_sites(){

        var open = false,
        $el = $('.all-sites'),
        $cols = $el.find('.row > div'),
        $triggers = $('[data-toggle="all-sites"]');

        $triggers.on('click', function(e){
            e.preventDefault();
            if( !open ){
                $el.animate({height: $el[0].scrollHeight}, 200, function(){
                    $el.css({height: 'auto'});
                });
                $triggers.addClass('all-sites-open');
                $triggers.find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
            }
            else {
                $el.animate({height: 0}, 200);
                $triggers.removeClass('all-sites-open');
                $triggers.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
            }

            open = !open;
        });

        logTime('After all_sites');

        /*
        var eq_height = function(){
        $cols.css({height:'auto'});
        setTimeout(function(){
        var max = 0;
        $cols.each(function(){
        max = Math.max(max, $(this).height());
    });
    $cols.height(max);
},50);
};
eq_height();
$(window).on('breakpoint', eq_height);
*/

})();

(function megamenu(){
    var $ul = $('.page-header .primary > .container > ul'),
    timeout;

    $ul.on('mouseenter', function(){
        clearTimeout(timeout);
        if ( $ul.hasClass('show-dropdowns') ){
            return;
        }
        timeout = setTimeout(function(){
            $ul.addClass('show-dropdowns');
        }, 200);
    }).on('mouseleave', function(){
        clearTimeout(timeout);
        $ul.removeClass('show-dropdowns');
    });
})();

/**
* Search (medium screen size)
*/
(function search_toggle(){
    var displayed = false;
    function toggle(e){
        if ( $(e.currentTarget).hasClass('search-input-label') && displayed) {
            return;
        }
        $('html').toggleClass('display-header-search');
    }

    $('.page-header .search-input-label, .page-header .search-input-close').click(toggle);
})();

logTime('search_toggle');

/**
* Popup links
*/
(function popup_links(){

    function popupCenter(url, title, w, h){
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

        width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 2) - (h / 2)) + dualScreenTop;
        var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }
    }

    $(document).on('click', '[data-action="popup"]', function(e){
        e.preventDefault();
        var $a = $(e.currentTarget);
        if ( !$a.data('id')) {
            $a.data('id', 'popup');
        }
        popupCenter($a[0].href, $a.data('id'), ($a.data('width')||800), ($a.data('height')||600));
    });
})();

logTime('popup_links');

/**
* Icon Blocks
*/
(function icon_blocks(){
    $('.widget_theme_iconblock > a.icon-block-wrap').each(function(){
        $(this).parent().addClass('is-link');
        var href = $(this).attr('href');
        $(this).parent().click( function(){
            window.location = href;
        });
    });
})();

logTime('icon_blocks');

/**
* Acordions
*/
(function accordions(){
    $(window).on('show.bs.collapse', function(e){
        $(e.target).parents('.panel').first().addClass('toggle-open');
    });
    $(window).on('hide.bs.collapse', function(e){
        $(e.target).parents('.panel').first().removeClass('toggle-open');
    });
})();

logTime('accordions');

/**
* Twitter Widget
*/
(function twitter_widget(){
    var swiper = $('.twitter-widget .swiper-container').swiper({
        mode              :'horizontal',
        loop              :true,
        calculateHeight   :true,
        simulateTouch     :false
    });
    $('.twitter-widget .swiper-container').addClass('-initialized');

    $('.twitter-widget .swipe-prev').click(function(){
        swiper.swipePrev();
    });
    $('.twitter-widget .swipe-next').click(function(){
        swiper.swipeNext();
    });
})();

logTime('twitter_widget');

/**
* Equal Height Blocks
*/
(function equal_heights(){

    var timeout = null;

    function update_heights(){
        $('[data-equal-heights]').each(function(){
            var sel = $(this).data('equal-heights'),
            max = 0,
            $els = $(this).find(sel);

            if( $.breakpoint() < breakpoints.SM ) {
                $els.css({height:'auto'});
            }
            else {
                $els.each(function(){
                    $(this).css({height:'auto'});
                    max = Math.max(max, $(this).outerHeight());
                });

                $els.css({height: max});
            }

        });
    }

    update_heights();

    $(window).on('breakpoint shown.bs.tab shown.bs.collapse', function(){
        if( timeout ) clearTimeout( timeout );
        timeout = setTimeout( update_heights, 10 );
    });
})();

logTime('equal_heights');

/**
* Off Canvas Navigation
*/
(function off_canvas_nav(){

    function OffCanvas(){
        var self = this;

        if( $(window).width() < breakpoints.MD ){
            this.init();
        }
        else {
            $(window).on('resize', function on_resize(){
                if( $(window).width() < breakpoints.MD ){
                    self.init();
                    $(window).off('resize', on_resize);
                }
            });
        }
    }

    $.extend(OffCanvas.prototype, {

        visible : false,

        classes : {
            show : 'show-off-canvas'
        },

        namespace : 'off-canvas',

        init : function(){
            // we need to build our menu...
            this.$el = $('.off-canvas');
            this.$content = $('.off-canvas-content');
            this.$trigger = $('[data-toggle="off-canvas"]');
            this.$mask = $('.off-canvas-mask');
            this.on( this.$trigger, 'click', this.toggle );
            this.on( this.$mask, 'click', this.onMaskClick );

        },

        on : function( $el, event, fn ){
            var self = this;
            $el.on(event, function(){
                fn.apply(self, arguments);
            });
        },

        off : function( $el, event, fn ){
            var self = this;
            $el.off(event, function(){
                fn.apply(self, arguments);
            });
        },

        onMaskClick : function(e){
            if( !$(e.target).hasClass('show') ) this.toggle(e);
        },

        toggle : function(e){
            var self = this;
            e.preventDefault();
            this.open = !$('html').hasClass( this.classes.show );

            var content = $('meta[name=viewport]').attr('content');

            if( this.open ){

                $('meta[name=viewport]').attr('content', content+', user-scalable=no');


                /**
                * Isn't this fun! Weird quirk with webkit where it will not
                * make this area scrollable until i mess with the height a bit.
                */
                var $content = this.$content;
                $content.css({'padding-bottom':'+=5'});
                setTimeout(function(){
                    $content.css({'padding-bottom':'-=5'});
                },200);

            }
            else {
                $('meta[name=viewport]').attr('content', content.replace(/\,\suser\-scalable\=no/, ''));
                this.$trigger.addClass('collapsed');

                var $mask = this.$mask;
                $mask.addClass('show');
                setTimeout(function(){
                    $mask.removeClass('show');
                },500);
            }
            $('html').toggleClass(this.classes.show);
            this.$trigger.find('.hamburger').toggleClass('collapsed');

        },

    });

    var offCanvas = new OffCanvas();
})();

logTime('off_canvas_nav');

/**
* Expanding Menus
*/
(function expanding_menus(){
    $(document).on('click.expanding-menus', '.expanding-menu a .item-toggle', function(e){
        e.preventDefault();
        var $li = $(this).parent().parent(),
        $ul = $li.find('> ul')

        var open = !$li.hasClass('menu-open');
        if ( open ) {
            $ul.css({height: 0});
        }
        $li.toggleClass('menu-open');

        if( open ){
            $ul.animate({height: $ul[0].scrollHeight}, 300, function(){
                $ul.css({height: 'auto'});
            });
        }
        else {
            $ul.animate({height: 0}, 300);
        }
    });
})();

logTime('expanding_nav');

(function sidebar_menu(){

    var $sidebarMenu = $('[data-component="sidebar-menu"]');

    if( !$sidebarMenu.length ) {
        return;
    }
    var $placeholder = $('<div />').css({display: 'none'}).insertBefore( $sidebarMenu ),
    $title = $sidebarMenu.find('>h5'),
    $menu = $sidebarMenu.find('>ul'),
    moved = false,
    open = false;

    function move_sidebar( ){

        var bp = $.breakpoint();

        // move to beginning of
        if ( bp < breakpoints.MD && !moved ) {
            $sidebarMenu.prependTo($('.bd > .container' ));
            moved = true;
        }

        // move it back
        else if ( bp > breakpoints.SM && moved ) {
            $sidebarMenu.insertAfter( $placeholder );
            moved = false;
        }
    }

    $(window).on('breakpoint', move_sidebar );
    move_sidebar();

    $title.on('click', function(e){
        if ( $.breakpoint() > breakpoints.SM ) return;
        $title.toggleClass('sidebar-menu-open');
        switch( $title.hasClass('sidebar-menu-open') ) {
            case true:
            $menu.animate({height: $menu[0].scrollHeight}, 300, function(){
                $menu.css({height: 'auto'});
            });
            break;
            case false:
            $menu.animate({height: 0}, 300);
            break;
        }
    });

})();

logTime('sidebar_menu');

/*
(function back_to_top(){
    var $el = $('.back-to-top');
    var displayed = false;
    $(window).on('scroll.back_to_top', function(){
        var st = $(this).scrollTop();
        if( st > 0 && !displayed){
            $el.addClass('displayed');
            displayed = true;
        }
        else if( st <= 0 && displayed ){
            $el.removeClass('displayed');
            displayed = false;
        }
    });

    $el.find('a').click(function(e){
        e.preventDefault();
        $(window).scrollTo(0, 200);
    });
})();

logTime('back_to_top');
*/
(function affix_sidebars(){
    if( !$.fn.affix ){
        return;
    }
    $('.asa-sidebar[data-behavior="affix"], .affix-small-sidebar').each(function(){
        var $this = $(this),
        $footer = $('.page-footer'),
        $parent = $this.parent();

        function updateWidth(){
            if ( $.breakpoint() > breakpoints.SM ) {
                $this.width( $parent.innerWidth() );
            }
            else {
                $this.css({'width':'auto'});
            }
        }

        updateWidth();
        $(window).on('breakpoint', updateWidth);
        var affixed = false;

        function setLeft(){
            if ( !affixed ) return;
            $this.css({left: $parent.offset().left+'px'});
        }

        function resetLeft(){
            $this.css({left: 0});
        }

        $(this).affix({
            offset : {
                top : function(){
                    var top = $parent.offset().top;
                    if ( $('#wpadminbar').is(':visible') ) {
                        top -= $('body').offset().top;
                    }
                    return top - 20 /* padding */;
                },
                bottom : function(){
                    var bottom = $footer.outerHeight();
                    if ( $('#wpadminbar').is(':visible') ) {
                        //bottom += $('#wpadminbar').height();
                    }
                    return bottom + 20;
                }
            }
        }).on('affixed.bs.affix', function(){
            affixed = true;
            setLeft();
        }).on('affixed-bottom.bs.affix affixed-top.bs.affix', function(){
            affixed = false;
            resetLeft();
        });

        $(window).on('resize', setLeft);
    });
})();
logTime('affix_sidebars');

/*
(function popovers(){
var open = null;
$('[data-tooltip-content]').popover({
content : function( e ){
return $(this).data('popover-content')
},
trigger : 'focus',
placement : 'top',
html : true
}).click(function(e){
e.preventDefault();
}).on('show.bs.popover', function(){
if( open ) $(open).popover('hide');
open = this;
});

})();
*/

(function tooltips(){
    $('body').tooltip({
        selector    :'[data-toggle="tooltip"]',
        container   :'html',
        boundary    :'.bd'
    });
    
})();

logTime('tooltips');

(function slideshows(){
    $('[data-component="slideshow"]').each(function(){
        var $el = $(this),
        $container = $el.parent(),
        pause = $el.data('pause') || 5000,
        autoplay = $el.data().autoplay !== false,
        remaining,
        timeout,
        lastTimeout

        function getParams(){
            return {
                mode            : 'horizontal',
                loop            : true,
                slidesPerView   : $.breakpoint() > breakpoints.SM ? 'auto' : 1,
                slidesPerViewFit: false,
                watchActiveIndex: true,
                simulateTouch   : false,
                calculateHeight : $.breakpoint() > breakpoints.SM ? false : true
            };
        }

        var swiper = new Swiper(this, getParams());
        $(this).data('swiper', swiper);

        $el.parent().find("[data-slideshow-nav]").click(function(e){
            e.preventDefault();
            var dir = $(this).data('slideshow-nav');
            var fn = 'swipe' + dir.substr(0,1).toUpperCase()+dir.substr(1);
            remaining = false;
            swiper[fn]();
            if ( autoplay ) bufferNext();
        });

        $(window).on('breakpoint', function(){
            $.extend( swiper.params, getParams() );
        });
        var resizeTimeout;
        $(window).on('resize', function(){
            clearTimeout( resizeTimeout );
            resizeTimeout = setTimeout( function(){ swiper.reInit(); }, 100 );
        });
        if( $.breakpoint() > breakpoints.SM ) {
            setTimeout( function(){
                swiper.reInit();
            }, 1000 );
        }

        function bufferNext() {
            clearTimeout( timeout );
            timeout = setTimeout(next, remaining || pause);
            lastTimeout = new Date().getTime();
        }

        function next(){
            clearTimeout( timeout );
            swiper.swipeNext();
            remaining = false;
            bufferNext();
        }

        if ( autoplay ) {
            $container.on('mouseover', function(){
                clearTimeout(timeout);
                remaining = Math.max( (remaining || pause) - (new Date().getTime() - lastTimeout), 1000 );
            }).on('mouseout', function(){
                bufferNext();
            });
            $el.imagesLoaded(function(){
                bufferNext();
            });
        }

    });
})();

logTime('slideshows');

(function partners(){
    $('[data-component="partners-carousel"]').each(function(){

        var $el = $(this)
        , timeout;

        function getParams(){
            return {
                mode            : 'horizontal',
                loop            : true,
                centeredSlides  : true,
                slidesPerView   : $.breakpoint() > breakpoints.SM ? 'auto' : 1,
                initialSlide    : 0,
                slidesPerViewFit: false,
                simulateTouch   : false,
                loopedSlides    : $.breakpoint() ? 15 : 1,
                calculateHeight : $.breakpoint() > breakpoints.SM ? false : true
            };
        }

        var swiper = new Swiper(this, getParams());

        $(window).on('breakpoint', function(){
            $.extend( swiper.params, getParams() );
        });

        var resizeTimeout;
        $(window).on('resize', function(){
            clearTimeout( resizeTimeout );
            resizeTimeout = setTimeout( function(){ swiper.resizeFix(); }, 100 );
        });

        $(this).parent().find("[data-nav]").click(function(e){
            e.preventDefault();
            var dir = $(this).data('nav');
            var fn = 'swipe' + dir.substr(0,1).toUpperCase()+dir.substr(1);
            swiper[fn]();
        });

        function next(){
            swiper.swipeNext();
            timeout = setTimeout(next, 3000);
        }

        $el.on('mouseover', function(){
            clearTimeout(timeout);
        }).on('mouseout', function(){
            //timeout = setTimeout(next, 3000);
        });

        $el.imagesLoaded(next);

    });
})();

logTime('partners_carousel');

(function tabs_init(){
    var scroll = true;
    var doScroll;
    function hashchange(e){
        var hash = window.location.hash.replace(/^#(tab:)/, '#');
        try {
            if( hash && $(hash) ){
                var $el = $(hash);
                if ( $el.hasClass('tab-pane') ) {
                    var $link = $el.parents('.tabbable').find('a[href="'+hash+'"][data-toggle="tab"]');
                    doScroll = scroll;
                    $link.tab('show');
                    if ( e && doScroll ) {
                        $(window).scrollTo($el.parents('.tabbable'), 500, {
                            offset : -60 - $('header.page-header').height()
                        });
                    }
                }
                else if ( $el.hasClass('panel-collapse') && !$el.parent('.beige-book').length ) {
                    doScroll = scroll;
                    $el.collapse('show');
                    if ( e && doScroll ) {
                        $(window).scrollTo($el, 500, {
                            offset : -60 - $('header.page-header').height()
                        });
                    }
                }
            }
        }
        catch(e){
            // this is likely just a non-element selector
        }
    }
    hashchange();
    $(window).on('hashchange', hashchange);
    $(window).on('show.bs.tab', function(e){
        scroll = false;
        window.location.hash = $(e.target).attr('href').replace(/#/,'#tab:');
        setTimeout(function(){
            scroll = true;
        }, 100);
    });
})();

logTime('tabs_init');

(function accordions_init(){
    var scroll = true;
    function hashchange(e){
        try {
            var hash = window.location.hash.replace(/^#(panel:)/, '#');
            $el = $(hash)
            if ( $el.hasClass('panel-collapse') && !$el.parents('.beige-book').length ) $el.collapse('show');
        }catch(e){}
    }
    hashchange();
    $(window).on('hashchange', hashchange);
    $(window).on('show.bs.collapse', function(e){
        //scroll = false;
        if ( $(e.target).data('no-hash') ) {
            return;
        }
        window.location.hash = '#panel:'+$(e.target).attr('id');
    });

    $(window).on('shown.bs.collapse', function(e){
        try {
            var hash = window.location.hash.replace(/^#(panel:)/, '#'),
            $el = $(hash);

            if( !$el.length ) return;

            var $panel = $el.parents('.panel'),
            $link = $panel.find('[data-toggle="collapse"]');

            var st = $(window).scrollTop(),
            o = $('body').offset().top + $('header.page-header').height(),
            wh = $(window).innerHeight(),
            h = $panel.innerHeight(),
            t = $panel.offset().top;

            if ( t > st+o && t+h < st+wh ) {
                return;
            }
            console.log( o );
            /*
            $(window).scrollTo($link, 500, {
                offset : -o -50,
                onAfter: function(){
                    console.log( 'afterScroll' );
                }
            });
            */
        }catch(e){};
    });
})();

logTime('accordions_init');

(function bordered_image_rows(){
    function add_margins() {
        $('.row.bordered-bottom-image img').each(function(){
            $(this).css({'margin-top':0});
            if( $.breakpoint() < breakpoints.MD) return;
            var $parent = $(this).parents('[class*=" col-"],[class^="col-"]').first();
            $row = $parent.parent();

            if ( $parent.height() < $row.height() ) {
                $(this).css({'margin-top': ($row.height()-$parent.height())});
            }
        });
    }

    $('.row.bordered-bottom-image').imagesLoaded(function(){
        add_margins();
        $(window).on('breakpoint', add_margins);
    });

})();

logTime('bordered_image_rows');

(function results_list(){
    $(document).on('click', '.results-list-header .view-options a', function(e){
        e.preventDefault();
        var $a = $(e.currentTarget);
        var style = $a.data('list-style');
        $a.parents('.results-list-container')
        .removeClass('list-style-blocks list-style-list')
        .addClass('list-style-'+style)

        $.cookie('results_list_style', style, {expires: 7, path:'/'});
    });

})();

logTime('results_list');

(function asa_dropdowns(){

    var $open = false;

    function toggleDropdown(e){
        e.stopPropagation();
        e.preventDefault();

        var $target = $(e.target),
        $dropdown = $target.parents('.dropdown').first();

        if( $open && !$dropdown.is($open) || $dropdown.hasClass('open')) {
            closeOpen();
        }

        else {
            $open = $dropdown;
            $dropdown.addClass('open');
            $open.animate({height: $open[0].scrollHeight}, 200);
        }
    }

    function closeOpen(){
        if ( $open ) {
            $open.animate({height: '2.5em'}, 200);
            $open.removeClass('open');
        }
        $open = false;
    }

    function closeIfOutsideClick(e){
        var $c = $(e.target);
        if ( !$c.parents('.dropdown-links-component').length &&
        !$c.parents('.dropdown-links-dropdown').length ) {
            closeOpen();
        }
    }

    $(document).on('click', '[data-toggle="asa-dropdown"]', toggleDropdown);
    $(document).on('click', closeIfOutsideClick);
})();

logTime('asa_dropdowns');

(function feed_archives(){

    $('select.select-box-it').each(function(){
        var $select = $(this),
        $selected = $select.find('option:selected'),
        text = $selected.text(),
        $optgroup = $selected.parents('optgroup')

        if ( $optgroup.length && $optgroup.attr('label').match(/^\d+$/) ) {
            text += ' '+$optgroup.attr('label');
        }

        // $select.selectBoxIt({
        //     'autoWidth'       : false,
        //     native            :true
        // });

        // $select.data().selectBoxSelectBoxIt.dropdownText.html(text);
    });
})();

logTime('feed_archives (select-box-it)');

(function print_fix(){
    function loadImages(){
        $('img[data-src]').each(function(){
            $(this).attr('data-unveil', null);
            $(this).attr('src', $(this).data('src'));
        });
    };
    window.onbeforeprint = loadImages;
    if ( window.matchMedia )
    window
    .matchMedia('print')
    .addListener(function(mql){
        if ( mql.matches)
        loadImages();
    });

})();

(function scroll_spy(){
    $('[data-scrollspy]').each(function(i){
        var $nav = $(this),
        spy = $nav.data('scrollspy'),
        id = $nav.attr('id')

        if ( !id ) {
            id = 'auto-scrollspy-'+(i+1);
            $(this).attr('id', id);
        }
        var selector = spy === true ? 'body' : spy;
        var $el = $(selector)
        .css({position:'relative'})
        .scrollspy({
            target      :'#'+id,
            offset      :$('body').offset().top+2
        });

        $nav.on('click', 'a', function(e){
            e.preventDefault();
            $.scrollTo( $(e.currentTarget).attr('href'), 100, {
                offset: {
                    left: 0,
                    top: -$('body').offset().top
                }
            });
        });
    });
})();

(function nav_arrows(){
    $('.asa-sidebar .nav-arrows').each(function(){
        var $nav = $(this),
        $arrow = $('<span />').appendTo($nav).addClass('arrow'),
        first = true;

        function moveArrow(){
            var p = $nav.find('.active').position();
            $arrow.stop().animate({
                top: p.top + ($nav.find('.active').height()/2)
            }, first ? 0 : 200 );
            first = false;
        }
        moveArrow();
        $nav.on('activate.bs.scrollspy', moveArrow);
    });
})();


(function asa_sliders(){
    $('.asa-slider').each(function(){
        var $slider = $(this),
        swiper = null,
        config = $slider.data(),
        swiperConfig = {
            loop            :true,
            loopedSlides    :4,
            mode            :'horizontal',
            calculateHeight :true
        },
        $container = $slider.find('.swiper-container')


        if( config.pagination !== false ){
            $('<div />')
            .addClass('swiper-pagination')
            .appendTo( $container )

            swiperConfig.pagination = '.swiper-pagination';
            swiperConfig.paginationClickable = true;

            $slider.addClass('has-pagination');
        }

        if ( config.arrows !== false ) {
            $.each(['Prev','Next'], function(i, dir){
                var arrow = dir == 'Next' ? 'right' : 'left';
                $('<div><a href="#"><i class="fa fa-angle-'+arrow+'"></i></a></div>')
                .addClass('nav-arrow nav-'+dir.toLowerCase())
                .appendTo($container)
                .attr('data-swiper-nav', dir)

                $container.on('click', '[data-swiper-nav]', function(e){
                    e.preventDefault();
                    var dir = $(e.currentTarget).data().swiperNav;
                    swiper['swipe'+dir]();
                });

                $slider.addClass('has-arrows');
            });
        }

        swiper = $slider.find('.swiper-container').swiper(swiperConfig);
        $slider.css({height:'auto'});
    });
})();

(function facts(){

    $('.fact-slider').each(function(){

        var $ct = $(this)
        , $facts = $ct.find('.facts')
        , $ul = $facts.find('> ul')
        , $items = $ul.find('> li')
        , rotator = new Fabrizio_Rotator($items)
        , dir
        , $bullets = $('<ul class="bullets" />').appendTo( $ct )
        ;

        for(var i =0; i< $items.length; i++){
            var $bullet = $('<li><a data-index="'+i+'" href="javascript:;"><i class="fa fa-circle"></i></a></li>').appendTo($bullets)
            if( i===0 ) $bullet.find('a').addClass('active');
        }

        $bullets.on('click', 'a', function(e){
            e.preventDefault();
            rotator.go( $(this).data('index') );
        });

        rotator.on('change', function(cur, last, i, j){
            var $cur = $(cur)
            , $last = $(last)

            $ul.height( $ul.height() );
            $cur.stop().fadeIn('slow');
            $('#facts').find('.toggle a').attr('href', '#answer-'+$cur.data('id'));
            $last.hide();
            $ul.stop().animate({height: $(cur).height()}, 200, function(){
                $ul.css('height','auto');
            });
            $ct.find('.index .current').html(i+1);
            $ct.find('.bullets a[data-index="'+i+'"]').addClass('active');
            $ct.find('.bullets a[data-index="'+j+'"]').removeClass('active');
        });

        $ct.on('click', '.nav-arrows a', function(e){
            e.preventDefault();
            dir = $(e.currentTarget).hasClass('next') ? 'next':'prev';
            rotator[dir]();
        });
    });
})();

logTime('print_fix');

(function send_to_kindle(){
    $(document).on('submit', 'form.send-to-kindle', function(e){
        e.preventDefault();
        var url = $(this).attr('action');
        var $form = $(this);
        var $children = $form.children();
        if ( !$form.find('input').val().match(/^.+@kindle\.com$/) ) {
            alert('Please enter a valid email address ending in @kindle.com');
        }
        var data = $form.serialize();
        var $loading = $('<span class="loading"><span class="fa fa-spin fa-cog"></span> Sending</span>');
        var displayAlert = function(type, message){
            return $(
                '<div class="alert alert-'+type+' fade in alert-dismissible">'+
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'+
                '<span aria-hidden="true">&times;</span>'+
                '</button>'+
                message +
                '</div>'
            );
        };
        $children.remove();
        $form.empty();
        $form.append( $loading );
        $.post(url, data )
        .done(function(response){
            var $alert;
            if( response.success ) {
                $alert = displayAlert('success','The e-book has been sent and should be available on your Kindle shortly!');
                $form.append( $alert );
                $form.append( $children );
                $form.find('input').val('');
            }
            else {
                $alert = alert('danger','An error occurred - please try sending again.');
                $form.append( $alert );
                $form.append( $children );
            }
        })
        .fail(function(){
            $alert = displayAlert('danger','An error occurred - please try sending again.');
            $form.append( $alert );
            $form.append( $children );
        })
        .always(function(){
            $loading.remove();
        });
    });
})();

$(document).on('click', '[data-ga-event]', function(e){
    var data = $(e.currentTarget).data('ga-event');
    if( window.dataLayer ){
        data.event = 'gaEvent';
        dataLayer.push( data );
    }
    else if( window.ga ){
        data.hitType = 'event';
        ga('send', data);
    }

});

$(document).on('change', 'select[data-toggle="tabs"]', function(e){

    var $select = $(e.target);
    var $tabs = $($select.data('target'));
    var id = $select.find('option:selected').val();

    $tabs.find('>div').hide();
    if ( id ) {
        $tabs.find('#'+id).show();
    }
});

$(document).on('show.bs.collapse', function(e){
    var id = $(e.target).attr('id');
    $('[href="#'+id+'"]').each(function(){
        if ( $(this).data('hide-text') ){
            if ( !$(this).data('show-text') ) {
                $(this).data('show-text', $(this).html() );
            }
            $(this).html( $(this).data('hide-text') );
        }
    });
});

$(document).on('hide.bs.collapse', function(e){
    var id = $(e.target).attr('id');
    $('[href="#'+id+'"]').each(function(){
        if ( $(this).data('show-text') ){
            if ( !$(this).data('hide-text') ) {
                $(this).data('hide-text', $(this).html() );
            }
            $(this).html( $(this).data('show-text') );
        }
    });
});

// (function scroll_to_hash(){
//     var id = window.location.hash.replace(/^#/,'');
//     if ( id ) {
//         try {
//             var $el = $('[data-id='+id+'],#'+id);
//             if ( !$el.length ) {
//                 return;
//             }
//             console.log(
//                 $el.offset().top, $('body').offset().top, $('header.page-header').height(),
//                 $el.offset().top - $('body').offset().top - $('header.page-header').height() - 80
//             );
//             $('html,body').animate({
//                 scrollTop: $el.offset().top - $('body').offset().top - $('header.page-header').height() - 80
//             }, 300);
//         }
//         catch(e){

//         }
//     }
// })();

$(document).on('click', 'a[data-back]', function(e){
    e.preventDefault();
    window.history.go(-1);
});

$(window).on('shown.bs.tab shown.bs.collapse shown.bs.modal', function(){
    $(window).trigger('lookup.unveil');
});

$(document).on('click', 'a', function(e){
    var href = $(this).attr('href');
    var $el;
    if ( href && href.match(/^#/) ) {
        try {
            $el = $(href);
            if( $el.hasClass('modal') ){
                e.preventDefault();
                $el.modal('show');
            }
        }
        catch( e ){
            // this is probalby just not a good element on the page, no big deal
        }
    }
});

$(document).on('click', '.asa-rating .editable.stars .star', function(e){
    // get the value...
    var $star = $(e.target);
    var value = $star.data('value');
    var $rating = $star.parents('.asa-rating');
    var $small = $rating.find('small');

    $star.parent().find('.star').removeClass('full half user-full');
    $star.addClass('user-full');

    $small.fadeOut(150, function(){
        $small.html('Saving <span class="fa fa-spin fa-spinner"></span>');
        $small.fadeIn(150);
    });

    $(document).trigger('asa-rating-click', [$rating.data('post-id'), value]);

    $.post( theme_vars.ajaxurl, {
        action      :'asa_rating_update',
        rating      :value,
        post_id     :$rating.data('post-id')
    }, function( response ){
        if ( response.success && response.html ) {
            $(document).trigger('asa-rating-change', [$rating.data('post-id'), value, response.html] );
        }
    });

});

$(document).on( 'asa-rating-change', function(ev, post_id, value, html){
    if( window.dataLayer ){
        dataLayer.push({
            event: 'gaEvent',
            eventCategory: 'Webinar Rating',
            eventAction: 'rated',
            eventLabel: document.title,
            eventValue: value
        });
    }
    $('.asa-rating[data-post-id="'+post_id+'"]').each(function(){
        var $rating = $(this);
        var $small = $rating.find('small');
        var $star = $rating.find('.star[data-value="'+value+'"]');
        $star.parent().find('.star').removeClass('full half user-full');
        $star.addClass('user-full');

        $small.fadeOut( 150, function(){
            $small.html( $(html).find('small').html() );
            $small.fadeIn( 150 );
        });
    });
});

$(function(){
    $('.rating-modal').each(function(){
        var $modal = $(this);
        var displayModal = function(){
            if( window.dataLayer ){
                dataLayer.push({
                    event: 'gaEvent',
                    eventCategory: 'Rating Overlay',
                    eventAction: 'displayed',
                    eventLabel: document.title
                });
            }
            $modal.css({opacity: 0, display: 'flex'});
            $modal.animate({opacity: 1});
        }
        var hideModal = function(){
            $modal.fadeOut('fast', function(){
                $modal.css({display: 'none'});
            });
        }
        $(document).on( 'click', '[href*="event.on24"][target="_blank"]', displayModal );
        $(document).on( 'asa-video-complete', displayModal );
        $(document).on( 'click', '.rating-modal [data-action="close"]', function(e){
            e.preventDefault();
            hideModal();
        });
        $(document).on( 'asa-rating-click', function( ev, post_id, value ){
            dataLayer.push({
                event: 'gaEvent',
                eventCategory: 'Rating Overlay',
                eventAction: 'rated',
                eventLabel: document.title,
                eventValue: value
            });
            $modal.find('.larger-text').css({opacity:0}).html('Thank you!').animate({opacity:1}, 300);
            setTimeout( hideModal, 1200 );
        });
    });
    if( location.hash === '#test-rating-overlay' ){
        $(document).trigger('asa-video-complete');
    }

});

    (function photoswipe_init(){
        var selector = 'a[data-width][data-height]:has(>img)';
        $(document).on('click', selector, function(e){
            var $tgt = $(e.target).closest('a');
            var $els = $(selector);
            var items = [];
            var index = 0;
            let i = 0;
            $els.each(function(){
                var $img = $(this).find('img');
                if( !$img.length ){
                    return;
                }
                var item = {
                    el: $img[0],
                    msrc: $(this).attr("href"),
                    src: $(this).attr("href") || $(this).data('pswp'),
                    w: parseInt($(this).attr('data-width'), 10),
                    h: parseInt($(this).attr('data-height'), 10)
                };
    
                if( this === $tgt[0] ){
                    index = i;
                }
                if( item.msrc && item.src && item.w && item.h ){
                    items.push(item);
                }
                i++;
    
            });
    
            if( !items.length ){
                return;
            }
            e.preventDefault();
            var pswp = new PhotoSwipe( document.getElementById('pswp'), PhotoSwipeUI_Default, items, {
                index: index,
                getThumbBoundsFn: false
            });
            pswp.listen('beforeChange', function(){
                $('#pswp a.pswp__button--download').attr('href', pswp.currItem.src);
            });
            pswp.init();
            window._pswp = pswp;
        });
    })();

});
